export const TRACKING_STARTED = 'TRACKING_STARTED';
